import HeroWithAbstract from './components/HeroWithAbstract';
import EndorsementsSection from './components/EndorsementsSection';
import TocSection from './components/TocSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <main>
        <HeroWithAbstract />
        <EndorsementsSection />
        <TocSection />
      </main>
      <Footer />
    </div>
  );
}